import { ResourceType } from '../../../typings/permissions';
import type { ReleaseGroupReleaseActions, ReleaseGroupReleaseAnyActions } from '../../../typings/permissions';

import useHasPermission from './useHasPermission';

/**
 * Helper hook for checking user's Release Group Release permissions.
 * @param releaseGroupId - The Release Group ID to check release permissions for.
 * @param action - The action to check for.
 * @returns Whether the user has the given permission for the given release group.
 */
const useHasReleaseGroupReleasePermission = (
  releaseGroupId: number,
  action: ReleaseGroupReleaseActions | ReleaseGroupReleaseAnyActions,
): boolean => {
  const hasPermission = useHasPermission();

  return (
    hasPermission({
      resourceType: ResourceType.ReleaseGroupReleaseAny,
      action,
    }) ||
    hasPermission({
      resourceType: ResourceType.ReleaseGroupRelease,
      action,
      releaseGroupId,
    })
  );
};

export default useHasReleaseGroupReleasePermission;
